import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=178a5ec1&scoped=true&"
import script from "./Specialty.vue?vue&type=script&lang=js&"
export * from "./Specialty.vue?vue&type=script&lang=js&"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=178a5ec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178a5ec1",
  null
  
)

export default component.exports